export enum DxGridDataType {
  TEXT = 'TEXT',
  LARGE_TEXT = 'LARGE_TEXT',
  INT = 'INT',
  DOUBLE = 'DOUBLE',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  TIME = 'TIME',
  DATE_TIME = 'DATE_TIME',
  DICTIONARY = 'DICTIONARY',
  LINK = 'LINK',
  CHECKBOX = 'CHECKBOX'
}
